import { generateLegacyQrCode, generateStyledQrCode } from '@/api/qrCode';
import { buildStyledQrConfig, isStyledQrConfig } from '@/utils/qrCodeUtils';

const rootConfig = {
    text: 'https://www.customily.com/',
    pixelSize: 20,
    lightColor: '#000000',
    darkColor: 'none'
};

const updatedConfig = (newConfig) => {
    if (!newConfig) return rootConfig;

    let config = {
        ...rootConfig,
        ...newConfig
    };

    return config;
};

(function () {
    'ngInject';

    angular.module('app.shared.services').service('QrUtilService', qrUtilService);

    function qrUtilService() {
        function fetchSvg(config) {
            // Both shapes go to the same generator: the styled ones carry `options`, the ones
            //  created before it keep their legacy config and use the service's legacy mode.
            if (isStyledQrConfig(config)) {
                return generateStyledQrCode(buildStyledQrConfig(config.options).options);
            }

            return generateLegacyQrCode(updatedConfig(config));
        }

        async function getQrSvg(config, mutex = null) {
            let svg = '';
            if (mutex != null) {
                await mutex.acquire();
                try {
                    svg = await fetchSvg(config);
                } finally {
                    mutex.release();
                }
            } else {
                svg = await fetchSvg(config);
            }
            return svg;
        }

        return {
            getQrSvg
        };
    }
})();
